import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    // maxWidth: 345,
    height: "100%",
    minHeight: 120,
    padding: 0,
  },
  mainCard: {
    padding: 0,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  cardTitle: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4
  },
  boxContent: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
}));

export const CardLayout = ({ title, children }) => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent className={classes.mainCard}>
        <Typography
          noWrap
          variant="subtitle1"
          component="h2"
          className={classes.cardTitle}
        >
          {title}
        </Typography>
        <Box className={classes.boxContent}>
          {children}
          {/* <Typography variant="body2" color="primary" component="p">
            This impressive paella is a perfect party dish and a fun meal to
            cook together with your guests. Add 1 cup of frozen peas along with
            the mussels, if you like.
          </Typography>

          <Button variant="contained" color="primary">
            Submit btn
          </Button> */}
        </Box>
      </CardContent>
    </Card>
  );
};

export default CardLayout;
